import request from "@/utils/http"
import store from "@/store"
import { getCachedObj } from "@/utils/cache"
import _ from "lodash"
import { Message } from "element-ui"

/**
 * 获取当前企业应用列表
 * @param type ALL, MEMBER, MANAGE
 * @returns {Promise<unknown>}
 */
export function getAppList(type = "MEMBER") {
  if (store.getters.isTemplateMode) return Promise.resolve([])
  return request.get("/users/getAppList", { params: { type } }).commonDeal()
}

export function getFavoriteList(type) {
  if (store.getters.isTemplateMode) return Promise.resolve([])
  return request.get("/users/getFavoriteList", { params: { type } }).commonDeal()
}

export function setFavoriteList(idList, type) {
  return request.post(`/users/setFavoriteList`, idList, { params: { type } })
}

export function deleteApp(appId, isTemplate) {
  return request.post("/users/app/delete", {}, { params: { appId, isTemplate } }).commonDeal()
}

export function copyApp(appId) {
  return request.post("/users/copyApp", {}, { params: { appId } })
}

export function exportApp(appId) {
  return request.post("/sheet/exportApp", {}, { params: { appId } }).commonDeal()
}

export function batchExportApp(appIds) {
  return request.post("/sheet/batchExportApp", appIds).commonDeal()
}

export function shareApp(appId) {
  return request.get(`/users/app/share/${appId}`).commonDeal()
}

export function createApp(app) {
  return request.post(`/users/app/create`, app).commonDeal()
}

export function updateApp(app) {
  return request.post(`/users/app/update`, app).commonDeal()
}

export function makeAppCode(appId) {
  return request.post(`/users/app/makeAppCode`, {}, { params: { appId } }).commonDeal()
}

// ///////////////////////////////////////////// 应用模板
export function getCurCompanyAppTemplates() {
  return request.get(`/users/getCurCompanyAppTemplates`).commonDeal()
}

export function getAppTemplateVersionList(id) {
  return request.get(`/users/getAppTemplateVersionList`, { params: { id } }).commonDeal()
}

export function createTemplate(app, appId) {
  return request.post(`/users/app/template/create`, app, { params: { appId } }).commonDeal()
}

export function commitAppTemplate(appPackage) {
  return request.post(`/users/commitAppTemplate`, appPackage).commonDeal()
}

export function publishAppTemplateVersion(desc, templateId) {
  return request
    .post(`/users/publishAppTemplateVersion`, null, { params: { desc, templateId } })
    .commonDeal()
}

export function switchAppTemplateVersion(templateId, version) {
  return request
    .post(`/users/switchAppTemplateVersion`, null, { params: { templateId, version } })
    .commonDeal()
}

/**
 * 安装模板
 * 可能会出现工作流发布失败，此时code为0，但有msg。需要弹框提醒用户
 * @param templateId
 * @param withData
 * @returns {Promise<AxiosResponse<any>>}
 */
export function installAppTemplate(templateId, withData = true) {
  return request.post(`/users/installApp`, null, { params: { templateId, withData } }).then(rsp => {
    let code = _.get(rsp, "data.code")
    let msg = _.get(rsp, "data.msg")
    let data = _.get(rsp, "data.data")
    if (msg != "ok") {
      Message.warning(msg)
    }
    if (code === 0) {
      return data
    }
    return Promise.reject(rsp?.data)
  })
}

/**
 * 获取跨应用设置
 * @param {String}} appId
 * @returns
 */
export function getExtraSheets(appId) {
  return request.get(`/sheet/getExtraSheets`, { params: { appId } }).commonDeal()
}

/**
 * 更新跨应用设置
 * @param {ExtraSheets} param0
 * @returns
 */
export function updateExtraSheets({ id, appId, extraSheets }) {
  return request.post(`/sheet/updateExtraSheets`, { id, appId, extraSheets }).commonDeal()
}

/**
 * 获取根据模板建的应用
 * @param {*} templateId
 * @returns
 */
export function getAppListByTemplate(templateId) {
  return request
    .get(`/users/appTemplate/getAppListByTemplate`, { params: { templateId } })
    .commonDeal()
}

/**
 * 应用模板更新指定应用
 * @param {*} templateId
 * @param {*} appIdList
 * @returns
 */
export function updateAppByTemplate(templateId, appIdList) {
  return request
    .post(`/users/appTemplate/updateAppByTemplate`, appIdList, { params: { templateId } })
    .commonDeal()
}
